// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oi-0";
export var buttonContainer = "_oi-3";
export var cancelButton = "_oi-4";
export var headerSection = "_oi-6";
export var headerTitle = "_oi-9";
export var messageSideLeft = "_oi-1";
export var messageSideRight = "_oi-2";
export var orderNumberContainer = "_oi-7";
export var orderNumberLabel = "_oi-8";
export var submitButton = "_oi-5";